export default {
  assignments: {},
  assignmentStats: {},
  classes: {},
  assignmentPosition: {},
};



// WEBPACK FOOTER //
// ./src/app/cat-assignment/store/state.js